<template>
  <div class="menu_seller_buyer">
    <div class="osk-wrapper">
      <ul>
        <li
          v-for="item in list"
          :key="item.anchor"
          @click="scrollToAnchor($event, item.anchor)"
        >
          <a :href="`#${item.anchor}`">
            <template v-if="item.alternativeLabel">
              <span>{{ item.label }}</span>
              <em>{{ item.alternativeLabel }}</em>
            </template>
            <template v-else>
              {{ item.label }}
            </template>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
type ListItem = {
  label?: string
  alternativeLabel?: string
  anchor: string
};

const props = withDefaults(defineProps<{
  list?: ListItem[]
}>(), {
  list: () => [],
});

function scrollToAnchor(event: Event, anchor: string) {
  event.preventDefault();

  const element = document.getElementById(anchor);

  if (!element) return;

  const elementTopPosition = element.getBoundingClientRect().top + document.documentElement.scrollTop;
  const headerHeightCorrection = window.innerWidth >= 1024 ? 169 : 56;

  window.scroll({
    top: elementTopPosition - headerHeightCorrection,
    behavior: 'smooth',
  });
}
</script>

<style lang="scss" scoped>
.menu_seller_buyer {
  padding: 30px 0;
  border-bottom: 1px solid rgba(51, 51, 51, 0.1);
}

.menu_seller_buyer .wrapper {
  max-width: 1120px;
}

.menu_seller_buyer ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.menu_seller_buyer ul li a {
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .8px;
}

.menu_seller_buyer ul li a em {
  display: none;
}

.menu_seller_buyer ul li a span {
  display: inline-block;
}

@media only screen and (max-width: 1024px) {
  .menu_seller_buyer {
    padding: 15px 0 4px;
  }

  .menu_seller_buyer ul li {
    text-align: center;
    width: calc(100% / 3);
    margin: 12px 0 23px;
  }

  .menu_seller_buyer ul li a {
    font-size: 14px;
  }

  .menu_seller_buyer ul li a em {
    display: inline-block;
  }

  .menu_seller_buyer ul li a span {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .menu_seller_buyer {
    display: none;
  }
}
</style>
